import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';

export const getDefaultStore = (favStore) => {
  try {
    if (favStore?.basicInfo?.id) return favStore;
    return JSON.parse(getLocalStorage('defaultStore')) || {};
  } catch (e) {
    return {};
  }
};

export const saveDefaultStore = (
  getFavoriteStoreById,
  formValues,
  favStore,
  isFavStoreUpdated,
  callback
) => {
  const [bopisStoreId] = formValues?.bopisStoreId || [];

  const defaultStore = getDefaultStore(favStore);
  const localStoreId = defaultStore?.basicInfo?.id;
  const [storeId] = bopisStoreId?.match(/\d+/) || [];
  const fullStoreId = `11${storeId}`;
  if (
    isFavStoreUpdated &&
    storeId &&
    bopisStoreId &&
    localStoreId &&
    fullStoreId !== localStoreId
  ) {
    getFavoriteStoreById({ storeId: fullStoreId });
    callback();
  }
};
